<div class="flex column gap-16">
  @if (
    selectedDetail().entry.status === "tracking-incomplete" ||
    selectedDetail().entry.status === "unknown"
  ) {
    <div class="banner caution">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4M12 16h.01" />
      </svg>
      <div class="banner-body">
        <strong style="color: var(--yellow-20); font-weight: 600"
          >Tracking incomplete.</strong
        >
        The indexer can't confirm the latest continuation and current UTXO.
        Spend actions are disabled until state is verified.
      </div>
    </div>
  }

  <div
    class="detail-header"
    [attr.data-tpl]="display.getTemplateKey(selectedDetail().entry)"
  >
    <div class="detail-title-row">
      <span class="tpl-icon" style="width: 52px; height: 52px">
        @switch (display.getTemplateKey(selectedDetail().entry)) {
          @case ("deadman") {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
          }
          @case ("timelock") {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="4" y="11" width="16" height="10" rx="2" />
              <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
          }
          @case ("multisig") {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="9" cy="9" r="3" />
              <path
                d="M15 6a3 3 0 0 1 0 6M4 20c0-2.8 2.2-5 5-5s5 2.2 5 5M16 15c2.2.4 4 2.4 4 5"
              />
            </svg>
          }
          @case ("escrow") {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 3v18M4 7h16M7 7l-3 6a3 3 0 0 0 6 0zM17 7l-3 6a3 3 0 0 0 6 0z"
              />
            </svg>
          }
          @case ("selfcustody") {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3l7 3v5c0 4.5-2.9 8.4-7 10-4.1-1.6-7-5.5-7-10V6z" />
              <path d="M9 12l2 2 4-5" />
            </svg>
          }
          @default {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
            >
              <circle cx="12" cy="12" r="9" />
            </svg>
          }
        }
      </span>
      <div class="detail-title-main">
        <div class="flex align-items-center gap-8 wrap">
          <h2 class="detail-title">
            {{ selectedDetail().entry.displayName }}
          </h2>
          <span
            class="status-badge"
            [class.active]="selectedDetail().entry.status === 'active'"
            [class.spent]="selectedDetail().entry.status === 'spent'"
            [class.tracking]="
              selectedDetail().entry.status === 'unknown' ||
              selectedDetail().entry.status === 'tracking-incomplete'
            "
            >{{ display.getStatusLabel(selectedDetail().entry) }}</span
          >
          <span class="source-badge">{{
            display.getSourceLabel(selectedDetail().entry)
          }}</span>
        </div>
        <p class="detail-blurb">
          {{ selectedDetail().entry.contractTypeLabel }} contract. Current state
          from covenant detail, active UTXOs, and action timeline.
        </p>
        @if (canEditContractAlias(selectedDetail().entry)) {
          @if (editingAliasKey() === getAliasEditKey(selectedDetail().entry)) {
            <div class="alias-editor detail-alias-editor">
              <input
                class="alias-input"
                type="text"
                placeholder="Contract nickname"
                [(ngModel)]="aliasDraft"
              />
              <button
                class="alias-btn"
                type="button"
                (click)="saveAlias(selectedDetail().entry)"
              >
                Save
              </button>
              <button
                class="alias-btn ghost"
                type="button"
                (click)="cancelAliasEdit()"
              >
                Cancel
              </button>
            </div>
          } @else {
            <div class="alias-actions">
              <button
                class="alias-link"
                type="button"
                (click)="beginAliasEdit(selectedDetail().entry)"
              >
                {{
                  selectedDetail().entry.aliasName
                    ? "Edit nickname"
                    : "Add nickname"
                }}
              </button>
              @if (selectedDetail().entry.aliasName) {
                <button
                  class="alias-link muted"
                  type="button"
                  (click)="removeAlias(selectedDetail().entry)"
                >
                  Remove nickname
                </button>
              }
              @if (canRemoveContract()) {
                <button
                  class="alias-link danger"
                  type="button"
                  (click)="removeTrackedContract(selectedDetail().entry)"
                >
                  Remove contract
                </button>
              }
            </div>
            @if (
              aliasNotice()?.key === getAliasEditKey(selectedDetail().entry)
            ) {
              <div class="alias-notice">
                {{ aliasNotice()!.message }}
              </div>
            }
          }
        } @else {
          <div class="alias-notice">
            {{ getAliasUnavailableMessage() }}
          </div>
        }
      </div>
      <div class="detail-title-actions">
        <button class="back-button p-8 typo-text-2" (click)="close()">
          Close
        </button>
      </div>
    </div>

    @if (selectedDetailLoading()) {
      <div class="text-gray-60 typo-text-2 p-12">
        Loading current indexer state...
      </div>
    }
    @if (selectedDetailError()) {
      <div class="error-message">{{ selectedDetailError() }}</div>
    }

    <div class="state-grid">
      <div class="state-cell">
        <span class="cell-label">Locked</span
        ><span class="cell-value"
          >{{
            display.formatSompiToKas(selectedDetail().entry.amountSompi)
          }}
          KAS</span
        >
      </div>
      <div class="state-cell">
        <span class="cell-label">Status</span
        ><span class="cell-value">{{
          display.getStatusLabel(selectedDetail().entry)
        }}</span>
      </div>
      @if (getSelfCustodyPhaseInfo(selectedDetail()); as phaseInfo) {
        <div class="state-cell">
          <span class="cell-label">initPhase</span
          ><span class="cell-value">{{ phaseInfo }}</span>
        </div>
      }
      @if (selectedDetail().entry.deadlineMs) {
        <div class="state-cell">
          <span class="cell-label">Check-in deadline</span
          ><span class="cell-value" style="font-size: 14px">{{
            display.formatTimestamp(selectedDetail().entry.deadlineMs)
          }}</span>
        </div>
      }
      <div class="state-cell">
        <span class="cell-label">Active UTXOs</span
        ><span class="cell-value">{{
          (selectedDetail().utxos || []).length
        }}</span>
      </div>
    </div>

    <div class="identifiers-row">
      @if (selectedDetail().entry.covenantId; as covenantId) {
        <div class="identifier">
          <span class="identifier-label">Covenant ID</span>
          <div class="identifier-value-row">
            @if (display.getCovenantExplorerLink(covenantId); as covenantLink) {
              <a
                class="identifier-value"
                [href]="covenantLink"
                target="_blank"
                rel="noopener noreferrer"
                [title]="covenantId"
                >{{ display.truncate(covenantId, 28) }}</a
              >
            } @else {
              <span class="identifier-value" [title]="covenantId">{{
                display.truncate(covenantId, 28)
              }}</span>
            }
            <app-copy-button
              [value]="covenantId"
              [size]="'sm'"
            ></app-copy-button>
          </div>
        </div>
      }
      @if (selectedDetail().entry.currentAddress; as currentAddress) {
        <div class="identifier">
          <span class="identifier-label">Contract address</span>
          <div class="identifier-value-row">
            <span class="identifier-value" [title]="currentAddress">{{
              display.truncate(currentAddress, 28)
            }}</span>
            <app-copy-button
              [value]="currentAddress"
              [size]="'sm'"
            ></app-copy-button>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="detail-cols">
    <!-- LEFT: actions + participants -->
    <div class="detail-col">
      @if (actionPageView() === "list" && !hideActionsAfterCompletion()) {
        <div class="panel">
          <div class="action-panel-head">
            <h4
              class="text-white"
              style="margin: 0; font-size: 14px; font-weight: 600"
            >
              Available actions
            </h4>
            @if (actionsPanelReady()) {
              @if (
                getCurrentRoleLabel(selectedDetail().entry.participants || []);
                as role
              ) {
                <span class="role-pill">You are {{ role }}</span>
              }
            }
          </div>
          <p class="text-gray-60 typo-text-2" style="margin: 0 0 14px">
            The wallet enables only the action available for your role and the
            contract's current state. Manual JSON interaction lives in Advanced.
          </p>
          <div class="action-list">
            @if (selectedDetail().entry.status !== "spent") {
              @if (!actionsPanelReady()) {
                <div class="action-list-skeleton">
                  @for (row of [1, 2, 3]; track row) {
                    <div class="action-item skeleton-action-item">
                      <div class="sk avatar"></div>
                      <div class="ai-text">
                        <div class="sk line wide"></div>
                        <div class="sk line"></div>
                      </div>
                    </div>
                  }
                </div>
              } @else if (availableActions(); as actions) {
                @if (actions.length > 0) {
                  @for (action of actions; track action.fnName) {
                    <button
                      class="action-item"
                      [class.primary]="action.enabled"
                      [disabled]="!action.enabled"
                      (click)="action.enabled && requestAction(action.fnName)"
                    >
                      <kc-icon
                        [iconClass]="action.iconClass"
                        [size]="'sm'"
                      ></kc-icon>
                      <span class="ai-text">
                        <span class="ai-title">{{ action.label }}</span>
                        <span class="ai-hint">{{
                          action.enabled
                            ? action.description
                            : action.disabledReason
                        }}</span>
                      </span>
                      @if (!action.enabled) {
                        <kc-icon
                          class="ai-lock"
                          [iconClass]="'icon-lock'"
                          [size]="'xs'"
                        ></kc-icon>
                      }
                    </button>
                  }
                } @else {
                  <button class="action-item" (click)="requestAction()">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 20h9" />
                      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" />
                    </svg>
                    <span class="ai-text"
                      ><span class="ai-title">Manual interaction</span
                      ><span class="ai-hint"
                        >This contract type has no curated actions — choose a
                        function and sign manually</span
                      ></span
                    >
                  </button>
                }
              }
            }
          </div>
        </div>
      }

      @if (partialSpendJsonForDetail(); as pendingSpendJson) {
        <div
          class="panel"
          style="
            background: rgba(255, 193, 7, 0.08);
            border: 1px solid rgba(255, 193, 7, 0.2);
          "
        >
          <h4
            class="text-yellow"
            style="margin: 0 0 8px; font-size: 14px; font-weight: 600"
          >
            Pending signature
          </h4>
          <p class="text-gray-75 typo-text-2" style="margin: 0 0 12px">
            Your signature has been added. Copy this JSON and send it to the
            co-signer to complete the transaction.
          </p>
          <textarea
            class="contract-input"
            rows="4"
            readonly
            [value]="pendingSpendJson"
          ></textarea>
          <kc-button
            [text]="'Copy partial spend JSON'"
            [isFullWidth]="true"
            (buttonClick)="copyPartialSpend()"
          ></kc-button>
          <kc-button
            [text]="'Download JSON file'"
            [variant]="'secondary'"
            [isFullWidth]="true"
            (buttonClick)="downloadPartialSpend()"
          ></kc-button>
        </div>
      }

      @if ((selectedDetail().entry.participants || []).length > 0) {
        <div class="panel">
          <h4
            class="text-white"
            style="margin: 0 0 12px; font-size: 14px; font-weight: 600"
          >
            Participants
          </h4>
          <div class="participant-list">
            @for (
              p of selectedDetail().entry.participants || [];
              track p.label + p.value
            ) {
              <div class="participant">
                <app-wallet-profile-orb
                  class="p-avatar"
                  [address]="p.value"
                  [sizePx]="26"
                ></app-wallet-profile-orb>
                <div class="p-body">
                  <span class="p-role">{{ p.label }}</span
                  ><span class="p-val" [title]="p.value">{{
                    display.truncate(p.value, 28)
                  }}</span>
                </div>
                <app-copy-button
                  [value]="p.value"
                  [size]="'sm'"
                ></app-copy-button>
              </div>
            }
          </div>
        </div>
      }

      @if (
        getSelfCustodyWhitelistWallets(selectedDetail());
        as whitelistWallets
      ) {
        @if (whitelistWallets.length > 0) {
          <div class="panel">
            <h4
              class="text-white"
              style="margin: 0 0 12px; font-size: 14px; font-weight: 600"
            >
              Whitelist
            </h4>
            <div class="participant-list">
              @for (wallet of whitelistWallets; track wallet) {
                <div class="participant">
                  <app-wallet-profile-orb
                    class="p-avatar"
                    [address]="wallet"
                    [sizePx]="26"
                  ></app-wallet-profile-orb>
                  <div class="p-body">
                    <span class="p-role">Allowed destination</span
                    ><span class="p-val" [title]="wallet">{{
                      display.truncate(wallet, 28)
                    }}</span>
                  </div>
                  <app-copy-button
                    [value]="wallet"
                    [size]="'sm'"
                  ></app-copy-button>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>

    <!-- RIGHT: timeline + advanced -->
    <div class="detail-col">
      @if ((selectedDetail().utxos || []).length > 0) {
        <div class="panel">
          <h4
            class="text-white"
            style="margin: 0 0 12px; font-size: 14px; font-weight: 600"
          >
            Current UTXO
          </h4>
          <div class="flex column gap-8">
            @for (
              utxo of selectedDetail().utxos || [];
              track (utxo.txidHex || "") + ":" + utxo.vout
            ) {
              <div
                class="utxo-row flex justify-content-between align-items-center gap-12"
              >
                @if (utxo.txidHex) {
                  <a
                    [href]="display.getExplorerLink(utxo.txidHex)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-blue typo-text-2"
                    >{{ display.truncate(utxo.txidHex, 24) }}:{{
                      utxo.vout || 0
                    }}</a
                  >
                } @else {
                  <span class="text-gray-60 typo-text-2"
                    >Unknown:{{ utxo.vout || 0 }}</span
                  >
                }
                <span class="text-white typo-text-2 fw-bold"
                  >{{
                    display.formatSompiToKas(
                      utxo.amountSompi?.toString() || "0"
                    )
                  }}
                  KAS</span
                >
              </div>
            }
          </div>
        </div>
      }

      <div class="panel">
        <h4
          class="text-white"
          style="margin: 0 0 4px; font-size: 14px; font-weight: 600"
        >
          Timeline
        </h4>
        <p class="text-gray-60 typo-text-2" style="margin: 0 0 14px">
          On-chain covenant history from the indexer.
        </p>
        <div class="timeline">
          @for (
            action of selectedDetail().actions.slice(0, 8);
            track (action.txidHex || "") +
              (action.action || "") +
              (action.entrypoint || "");
            let last = $last
          ) {
            <div class="tl-row">
              <div class="tl-rail">
                <span class="tl-dot"></span>
                @if (!last) {
                  <span class="tl-line"></span>
                }
              </div>
              <div class="tl-body">
                <div class="tl-head">
                  <span class="tl-action">{{
                    display.formatActionName(
                      action.entrypoint || action.action || "action"
                    )
                  }}</span>
                  @if (action.txidHex) {
                    <a
                      class="tl-tx"
                      [href]="display.getExplorerLink(action.txidHex)"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ display.truncate(action.txidHex, 16) }}</a
                    >
                  }
                </div>
                <span class="tl-when">{{
                  display.formatTimestamp(action.blockTimeMs)
                }}</span>
              </div>
            </div>
          }
        </div>
      </div>

      <details class="advanced-section">
        <summary>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="3" />
            <path
              d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
            />
          </svg>
          Advanced technical data
        </summary>
        <div class="adv-body">
          @if (selectedDetail().entry.scriptHash; as scriptHash) {
            <div class="adv-row">
              <span class="adv-label">Script hash</span>
              <div class="identifier-value-row">
                <span class="adv-value">{{ scriptHash }}</span>
                <app-copy-button
                  [value]="scriptHash"
                  [size]="'sm'"
                ></app-copy-button>
              </div>
            </div>
          }
        </div>
      </details>
    </div>
  </div>
</div>
